/**
 * Filtra opções que contêm "Não Informado" dos dropdowns de cadastro/edição
 * @param options - Array de opções do dropdown
 * @param nameField - Campo que contém o nome (ex: 'nome_mercado', 'nome_canal_venda')
 * @returns Array filtrado sem opções "Não Informado"
 */
export const filterNotInformedOptions = <T extends Record<string, any>>(
	options: T[],
	nameField: string
): T[] => {
	if (!options || !Array.isArray(options)) {
		return [];
	}

	return options.filter(option => {
		const name = option[nameField];
		return name && name !== 'Não Informado' && name.trim() !== '';
	});
};

/**
 * Filtra opções de hierarquia que contêm "Não Informado"
 * @param options - Array de opções do dropdown
 * @returns Array filtrado sem opções "Não Informado"
 */
export const filterHierarchyNotInformedOptions = <
	T extends Record<string, any>
>(
	options: T[]
): T[] => {
	return (
		filterNotInformedOptions(options, 'nome_mercado') ||
		filterNotInformedOptions(options, 'nome_canal_venda') ||
		filterNotInformedOptions(options, 'nome_forca_venda') ||
		filterNotInformedOptions(options, 'nome_zona_venda') ||
		filterNotInformedOptions(options, 'nome_membro') ||
		filterNotInformedOptions(options, 'nome_familia') ||
		filterNotInformedOptions(options, 'nome_subfamilia') ||
		filterNotInformedOptions(options, 'nome_modelo') ||
		filterNotInformedOptions(options, 'nome_cliente') ||
		options
	);
};
